import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  it: {
    explore: "Esplora",
    leaderboard: "Classifica",
    rewards: "Livelli",
    family: "Famiglia",
    race: "Gare",
    admin: "Admin",
    login: "Accedi",
    logout: "Esci",
    register: "Registrati",
    welcomeBack: "Bentornato!",
    accountCreated: "Account creato!",
    points: "punti",
    minutes: "min",
    free: "Gratis",
    locked: "Bloccato",
    start: "Inizia",
    startAdventure: "Inizia l'avventura",
    buy: "Acquista",
    routesAvailable: "Percorsi disponibili",
    adventures: "avventure",
    backpack: "nel tuo zaino",
    backToHome: "Torna alla home",
    back: "Indietro",
    routeCompleted: "Tesoro trovato!",
    raceMode: "Modalità gara",
    timeBonus: "Bonus tempo",
    joinRace: "Partecipa",
    alreadyJoined: "Partecipi già",
    raceLeaderboard: "Classifica gara",
    duration: "Durata",
    completed: "Completato",
    inProgress: "In corso",
    familyArea: "Area Famiglia",
    createFamily: "Crea famiglia",
    joinFamily: "Unisciti",
    members: "membri",
    progress: "Progressi",
    overview: "Generale",
    childProgress: "Progressi dei membri",
    monthlyPoints: "Punti mensili",
    photoProof: "Foto-prova",
    takePhoto: "Scatta una foto",
    photoSent: "Foto inviata, ottimo!",
    languageIt: "Italiano",
    languageEn: "English",
  },
  en: {
    explore: "Explore",
    leaderboard: "Leaderboard",
    rewards: "Levels",
    family: "Family",
    race: "Races",
    admin: "Admin",
    login: "Login",
    logout: "Logout",
    register: "Sign up",
    welcomeBack: "Welcome back!",
    accountCreated: "Account created!",
    points: "points",
    minutes: "min",
    free: "Free",
    locked: "Locked",
    start: "Start",
    startAdventure: "Start the adventure",
    buy: "Buy",
    routesAvailable: "Available routes",
    adventures: "adventures",
    backpack: "in your backpack",
    backToHome: "Back to home",
    back: "Back",
    routeCompleted: "Treasure found!",
    raceMode: "Race mode",
    timeBonus: "Time bonus",
    joinRace: "Join",
    alreadyJoined: "Already joined",
    raceLeaderboard: "Race leaderboard",
    duration: "Duration",
    completed: "Completed",
    inProgress: "In progress",
    familyArea: "Family Area",
    createFamily: "Create family",
    joinFamily: "Join",
    members: "members",
    progress: "Progress",
    overview: "Overview",
    childProgress: "Members progress",
    monthlyPoints: "Monthly points",
    photoProof: "Photo proof",
    takePhoto: "Take a photo",
    photoSent: "Photo sent, great!",
    languageIt: "Italian",
    languageEn: "English",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("odismap_lang") || "it");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("odismap_lang", l);
    setLangState(l);
  };

  const t = (key) => DICT[lang]?.[key] ?? DICT.it[key] ?? key;

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
